import convertDataFrameToRunQueryOutput from 'data-frames/util/legacy/convertDataFrameToRunQueryOutput';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

import {
  LegacyRunQueryOutput,
  LegacyRunQueryState,
  RunQueryOutput,
  RunQueryState,
} from './AnalyticsWarehouseTypes';

export default function convertRunQueryOutputToLegacyOutput(
  runQueryOutput: RunQueryOutput
): LegacyRunQueryOutput {
  return {
    ...runQueryOutput,
    ...convertDataFrameToRunQueryOutput(runQueryOutput.dataFrame, false),
  };
}

export function convertRunQueryStateToLegacyState<TLegacyRunQueryState extends LegacyRunQueryState>(
  runQueryState: RunQueryState
): TLegacyRunQueryState {
  switch (runQueryState.status) {
    case AsyncStatus.SUCCESS:
      return {
        ...runQueryState,
        data: convertRunQueryOutputToLegacyOutput(runQueryState.data),
      } as TLegacyRunQueryState;
    case AsyncStatus.LOADING:
      return {
        ...runQueryState,
        ...((runQueryState.previousData == null
          ? {previousData: null}
          : {
              previousData: convertRunQueryOutputToLegacyOutput(runQueryState.previousData),
            }) as TLegacyRunQueryState),
      };
    default:
      return runQueryState as TLegacyRunQueryState;
  }
}
